import { Modal } from '@/components/Layout';
import React from 'react';
import { useLessons } from './lessons.hook';
import { Button } from '@/components/Common';

const LessonDeletionModal = () => {
  const {
    isDeletePending,
    onDeleteLesson,
    openLessonDeletionModal,
    lessonDeletionModal,
  } = useLessons();
  return (
    <Modal
      isOpen={lessonDeletionModal}
      onClose={openLessonDeletionModal}
      modalStyle="bg-[#2A2A2A] min-w-[23.4375rem]"
      headerStyle="bg-[#2A2A2A]"
    >
      <div className="flex flex-col gap-1">
        <h3 className="text-white text-xl font-bold text-center mb-2">
          Supprimer la leçon
        </h3>
        <p className="text-center text-gray-400 mx-auto my-0">
          Êtes-vous sûr de vouloir supprimer ?{' '}
        </p>
        <div className="flex justify-between items-center gap-6  mt-4">
          <Button
            onClick={openLessonDeletionModal}
            title="Annuler"
            className="!bg-completed hover:!outline-completed hover:!text-completed
                hover:!bg-hoverColor  text-white !px-16"
          />
          <Button
            className="!px-16"
            title={isDeletePending ? 'Suppression en cours...' : 'Supprimer'}
            onClick={onDeleteLesson}
          />
        </div>
      </div>
    </Modal>
  );
};

export default LessonDeletionModal;
